import { TYPO } from "styles/Typo";

function ToggleButton({
  active,
  setActive,
  title1,
  title2,
  typo,
  dataGtmId,
}: {
  active: number;
  setActive: (active: number) => void;
  title1: string;
  title2: string;
  typo?: string;
  dataGtmId?: string;
}) {
  return (
    <div
      className="bg-gray5 border border-gray15 rounded-[10px] relative p-1 flex  cursor-pointer box-border"
      onClick={() => {
        setActive(active === 1 ? 2 : 1);
      }}
      data-gtm-id={dataGtmId}
    >
      <div
        className="absolute top-[50%] translate-y-[-50%] left-[4px] w-[37px]  bg-white z-[0] rounded-[6px] box-border"
        style={{
          transform: `translate(
        ${active === 1 ? "0%" : "calc(100%)"},
        -50%
      )`,
          transition: "transform 0.3s ease-in-out",
          height: "calc(100% - 8px)",
        }}
      ></div>
      <p
        className={`${typo || TYPO.TYPO9_MD} text-gray80 px-2 py-[2px] z-[1] ${
          active === 1 ? "" : ""
        }`}
      >
        {title1}
      </p>
      <p
        className={`${typo || TYPO.TYPO9_MD} text-gray80 px-2 py-[2px] z-[1] ${
          active === 2 ? "" : ""
        }`}
      >
        {title2}
      </p>
    </div>
  );
}

export default ToggleButton;
